import { useLoggingContext } from "@/providers/logging-provider/logging-provider";
import { useState } from "react";

export const useCancelProcess = (
  endpoint: string,
  query: URLSearchParams,
  forceCancel: () => Promise<void>,
) => {
  const logger = useLoggingContext();

  const [isLoading, setIsLoading] = useState(false);

  const cancelProcess = async () => {
    try {
      setIsLoading(true);

      const response = await fetch(endpoint + query, {
        method: "DELETE",
      });

      if (response.ok) {
        return;
      }

      if (response.status === 404) {
        await forceCancel();
      }
    } catch (err) {
      logger.logError(err as Error);
    } finally {
      setIsLoading(false);
    }
  };

  return { cancelProcess, isLoading };
};
